import { Box, Paper, Typography, Alert } from "@mui/material";
import { useEffect, useState } from "react";
import { callApi } from "../../helpers/CallAPI";
import { getApiKey } from "../../helpers/Utils";
import { apiBaseUrl, apiPaths } from "../../constants/ApiUrl";
import { useNavigate } from "react-router-dom";
import ButtonsComponent from "./form/ButtonsComponent";
import "../../styles/ManageDashboard.css";
import FormComponent from "./form/FormComponent";

const CreateDashboard: React.FC<{ handleCancel }> = ({ handleCancel }) => {
  const [displayTypes, setDisplayTypes] = useState([]);
  const [selectedDisplayType, setSelectedDisplayType] = useState(null);
  const [name, setName] = useState("");
  const [hashtagText, setHashTagText] = useState("");
  const [inTitleContent, setInTitleContent] = useState(false);
  const [hashtags, setHashtags] = useState([]);
  const [nameError, setNameError] = useState("");
  const [hashtagsTextError, setHashtagsTextError] = useState("");
  const [hashtagsError, setHashtagsError] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState<
    "info" | "success" | "error" | "warning"
  >("info");
  const navigate = useNavigate();
  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    const apiKey = getApiKey();
    if (apiKey) {
      callApi(apiKey, apiBaseUrl + apiPaths.displayType, "GET")
        .then((data) => {
          setDisplayTypes(data);
        })
        .catch((e) => {
          const error = JSON.parse(e.message);
          if (error.status === 403) {
            navigate("/login");
          }
        });
    } else {
      navigate("/login");
    }
  };
  const handleAddHashtag = () => {
    if (!hashtagText) {
      setHashtagsTextError("Please input the hashtag before add");
      return;
    } else {
      setHashtagsTextError("");
    }
    setHashtags([
      ...hashtags,
      { hashtag: hashtagText, intitlecontent: inTitleContent },
    ]);
    setHashTagText("");
    setInTitleContent(false);
  };

  const handleRemoveHashtag = (index) => {
    const updatedHashtags = hashtags.filter((_, i) => i !== index);
    setHashtags(updatedHashtags);
  };

  const handleSubmit = () => {
    var validated = true;
    if (!name) {
      setNameError("Please input the dashboard name");
      validated = false;
    } else {
      setNameError("");
    }
    if (hashtags.length === 0) {
      setHashtagsError("Please add at least one hashtag");
      validated = false;
    } else {
      setHashtagsError("");
    }
    if (!validated) {
      return;
    }
    const apiKey = getApiKey();
    if (apiKey) {
      callApi(
        apiKey,
        apiBaseUrl + apiPaths.create,
        "POST",
        JSON.stringify({ name: name, hashtags: hashtags, displayType: selectedDisplayType ? selectedDisplayType : 1 })
      )
        .then((data) => {
          setName("");
          setHashtags([]);
          setHashTagText("");
          setInTitleContent(false);
          setSelectedDisplayType(null)
          setMessage("Create successfully");
          setMessageType("success");
          setShowMessage(true);
        })
        .catch((e) => {
          const error = JSON.parse(e.message);
          if (error.status === 403) {
            navigate("/login");
          } else if (error.status === 409) {
            setMessage(`Already existed dashboard with name ${name}`);
            setMessageType("error");
            setShowMessage(true);
          } else {
            setMessage("Something went wrong. Please check again");
            setMessageType("error");
            setShowMessage(true);
          }
        });
      setTimeout(() => {
        setShowMessage(false);
        setMessage("");
      }, 5000);
    } else {
      navigate("/login");
    }
  };

  return (
    <Box className="paper-container">
      <Paper className="paper-main" elevation={4}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{ color: "#ffffff" }}
        >
          Create Dashboard
        </Typography>

        {/* Name Field */}
        {showMessage && message ? (
          <Alert
            severity={messageType}
            sx={{ width: "90%", marginTop: "20px", marginBottom: "10px" }}
          >
            {message}
          </Alert>
        ) : null}
        <FormComponent
          name={name}
          handleAddHashtag={handleAddHashtag}
          handleRemoveHashtag={handleRemoveHashtag}
          hashtagText={hashtagText}
          hashtags={hashtags}
          hashtagsError={hashtagsError}
          hashtagsTextError={hashtagsTextError}
          inTitleContent={inTitleContent}
          nameError={nameError}
          onChangeHashtagText={(e) => {
            if (e.target.value.trim()) {
              setHashtagsTextError("");
            }
            setHashTagText(e.target.value);
          }}
          onChangeInTitleContent={(_, checked) => {
            setInTitleContent(checked);
          }}
          onChangeName={(e) => {
            if (e.target.value.trim()) {
              setNameError("");
            } else {
              setNameError("Please input the dashboard name");
            }
            setName(e.target.value);
          }}
          onSelectDisplayType={(e) => {
            const value = e.target.value;
            setSelectedDisplayType(value);
          }}
          displayTypes={displayTypes}
          selectedDisplayType={selectedDisplayType}
        />
        <ButtonsComponent
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
        />
      </Paper>
    </Box>
  );
};

export default CreateDashboard;
